import React from 'react';
import { Article, BoxProps } from '../box';
import { LinkProps } from '../link/link';

export interface BaseCardProps extends BoxProps {
  decoration?: LinkProps['decoration'];
  onFocus?: React.FocusEventHandler<HTMLElement>;
  onBlur?: React.FocusEventHandler<HTMLElement>;
}

const BaseCard = ({ href, componentClass, onClick, to, onFocus, onBlur, disabled, ...rest }: BaseCardProps) => {
  const accessibilityProps: { role?: 'button'; tabIndex?: 0 } = {};
  const isLink = to || href || componentClass === 'a';
  const isButton = componentClass === 'button';

  if (onClick && !isButton && !isLink) {
    accessibilityProps['role'] = 'button';
    accessibilityProps['tabIndex'] = 0;
  }

  return (
    <Article
      componentClass={componentClass}
      onKeyDown={e => {
        if ((e.key === 'Enter' || e.key === ' ') && !isLink && !isButton && !disabled) {
          // preventing default here because of this bug in radix modals (which are used in gig)
          // https://github.com/radix-ui/primitives/issues/1794
          // also prevents the page scrolling when Space is used to activate a role="button" card
          e.preventDefault();
          //@ts-expect-error
          return onClick(e);
        }
      }}
      to={to}
      onClick={disabled ? undefined : onClick}
      href={href}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      {...accessibilityProps}
      {...rest}
    />
  );
};

export default BaseCard;
